import { memo } from 'react';

import { ButtonV3 } from 'components/ComponentV2';
import CreateWithAI from './CreateWithAI';

import styles from './EmptyBottomSection.module.scss';

interface EmptyBottomSectionProps {
  desc: string;
  addButtonText: string;
  createWithAIButton: boolean;
  onAddIconClick: () => void;
  onAIButtonClick?: () => void;
}

export const EmptyBottomSection = memo(
  ({
    desc,
    addButtonText,
    createWithAIButton,
    onAddIconClick,
    onAIButtonClick,
  }: EmptyBottomSectionProps) => {
    return (
      <article className={styles.container}>
        <section className={styles['content-box']}>
          <p className={styles.description}>{desc}</p>
        </section>
        <section className={styles['button-section']}>
          <ButtonV3
            color="secondary"
            startIcon="icon_plus"
            onClick={onAddIconClick}
          >
            {addButtonText}
          </ButtonV3>
          {createWithAIButton && (
            <CreateWithAI onAIButtonClick={onAIButtonClick} />
          )}
        </section>
      </article>
    );
  }
);

EmptyBottomSection.displayName = 'EmptyBottomSection';
